import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import {
  searchNavButton,
  searchNavButtons,
} from '../../backend/types/search-nav-buttons';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteSearchService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/search`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  search(search: string): Observable<searchNavButtons> {
    return this.http.get<searchNavButtons>(`${this.urlRoute}`, {
      params: {
        search,
      },
    });
  }

  searchV2(search: string): Observable<searchNavButton[]> {
    return this.http.get<searchNavButton[]>(`${this.urlRoute}`, {
      params: {
        search,
      },
    });
  }
  searchV3(search: string, type: string): Observable<searchNavButton[]> {
    return this.http.patch<searchNavButton[]>(this.urlRoute, {
      search: search,
      type: type,
    });
  }
}
